import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['textarea', 'clear', 'caption']

    declare readonly textareaTarget: HTMLTextAreaElement
    declare readonly hasTextareaTarget: boolean
    declare readonly captionTarget: HTMLElement
    declare readonly hasCaptionTarget: boolean

    clear(event: Event) {
        event.preventDefault()
        const textarea = this.resolveTextarea()
        if (!textarea || textarea.hasAttribute('disabled')) return
        textarea.value = ''
        textarea.dispatchEvent(new Event('input', { bubbles: true }))
        textarea.dispatchEvent(new Event('change', { bubbles: true }))
    }

    connect() {
        this.element.addEventListener('textarea:add-error', this.onAddError as EventListener)
        this.element.addEventListener('textarea:clear-error', this.onClearError as EventListener)
        this.element.addEventListener('textarea:set-loading', this.onSetLoading as EventListener)
        this.element.addEventListener('textarea:set-success', this.onSetSuccess as EventListener)
    }

    disconnect() {
        this.element.removeEventListener('textarea:add-error', this.onAddError as EventListener)
        this.element.removeEventListener('textarea:clear-error', this.onClearError as EventListener)
        this.element.removeEventListener('textarea:set-loading', this.onSetLoading as EventListener)
        this.element.removeEventListener('textarea:set-success', this.onSetSuccess as EventListener)
    }

    private onAddError = (e: CustomEvent) => {
        const message = (e.detail && (e.detail.message as string)) || ''
        const textarea = this.resolveTextarea()
        if (!textarea) return
        textarea.classList.remove('success', 'loading')
        textarea.classList.add('error')
        if (this.hasCaptionTarget) this.captionTarget.textContent = message
    }

    private onClearError = () => {
        const textarea = this.resolveTextarea()
        if (!textarea) return
        textarea.classList.remove('error')
        if (this.hasCaptionTarget) this.captionTarget.textContent = ''
    }

    private onSetLoading = (e: CustomEvent) => {
        const value = !!(e.detail && e.detail.loading)
        const textarea = this.resolveTextarea()
        if (!textarea) return
        textarea.classList.toggle('loading', value)
        if (value) textarea.classList.remove('error', 'success')
    }

    private onSetSuccess = (e: CustomEvent) => {
        const value = !!(e.detail && e.detail.success)
        const textarea = this.resolveTextarea()
        if (!textarea) return
        textarea.classList.toggle('success', value)
        if (value) textarea.classList.remove('error', 'loading')
    }

    private resolveTextarea(): HTMLTextAreaElement | null {
        if (this.hasTextareaTarget) return this.textareaTarget
        return this.element.querySelector('textarea.textarea') as HTMLTextAreaElement | null
    }
}


